<template>
    <el-form
        ref="loginForm"
        :model="form"
        :rules="rules"
        @keyup.enter.native="onSubmit"
    >
        <p class="orangetext" v-if="currentAward">
            Log in your account in order to submit your project for
            {{ currentAwardName }}. The information and project details provided
            here must be accurate. All information submitted will be included in
            all online presentation, exhibition and Award publication catalogue.
            Please ensure that possible changes or mistakes according to
            credits, images and project description may incur costs.
        </p>
        <el-form-item
            prop="email"
            :error="$t(formErrors.get('email'))"
            class="form-group"
        >
            <el-input
                v-model="form.email"
                name="email"
                :placeholder="$t('auth.login.email_label') + ' *'"
                type="text"
            />
        </el-form-item>
        <el-form-item
            prop="password"
            :error="$t(formErrors.get('password'))"
            class="form-group"
        >
            <el-input
                v-model="form.password"
                name="password"
                :placeholder="$t('auth.login.password_label') + ' *'"
                type="password"
                show-password
            />
        </el-form-item>
        <el-row>
            <el-col :xs="24" :md="12">
                <el-checkbox
                    v-model="form.remember_token"
                    value="form.remember_token"
                    >Keep me signed in</el-checkbox
                ><BR />
                <router-link
                    v-if="currentAward"
                    :to="forgotLink"
                    class="forgotLink"
                    >Forgot your password?</router-link
                >
            </el-col>
            <el-col :xs="24" :md="12" class="text-right">
                <el-button
                    :loading="loading"
                    class="loginButton"
                    @click.native="onSubmit"
                >
                    {{ $t("auth.login.submit_button") }}
                </el-button>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
import { Errors } from "../../../includes/Errors";
import { mapGetters } from "vuex";

export default {
    name: "LoginForm",
    props: {
        errors: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: {
                email: "",
                password: "",
                remember_token: "",
                device_name: this.config.deviceName,
            },
            rules: {
                email: [
                    {
                        required: true,
                        message: this.$t("global.form.rules.required", {
                            fieldName: this.$t("auth.login.email_label"),
                        }),
                        trigger: "blur",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: this.$t("global.form.rules.required", {
                            fieldName: this.$t("auth.login.password_label"),
                        }),
                        trigger: "blur",
                    },
                ],
            },
            formErrors: new Errors(),
        };
    },
    watch: {
        errors: function () {
            this.formErrors.record(this.errors);
        },
    },
    methods: {
        onSubmit(e) {
            this.$refs["loginForm"].validate((valid) => {
                if (valid) {
                    this.$emit("submit", {
                        ...this.form,
                    });
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
.el-form-item__label {
    padding: 0 !important;
}

.sign-up-form {
    .el-form-item {
        margin-bottom: 12px;

        .el-form-item__label {
            padding: 0 !important;
        }
    }
}
</style>
